import PropTypes from 'prop-types';
import { Box, IconButton, TablePagination } from '@mui/material';
import { FirstPage, KeyboardArrowLeft, KeyboardArrowRight, LastPage } from '@mui/icons-material';

const TablePaginationActions = (props) => {
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };

  return (<Box sx={{ flexShrink: 0, ml: 2.5 }}>
    <IconButton onClick={handleFirstPageButtonClick} disabled={page === 0} aria-label="first page"><FirstPage /></IconButton>
    <IconButton onClick={handleBackButtonClick} disabled={page === 0} aria-label="previous page"><KeyboardArrowLeft /></IconButton>
    <IconButton onClick={handleNextButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label="next page"><KeyboardArrowRight /></IconButton>
    <IconButton onClick={handleLastPageButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1} aria-label="last page"><LastPage /></IconButton>
  </Box>);
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};

const TablePaginationComponent = (props) => {

  return (<TablePagination
    rowsPerPageOptions={[25, 50, 100]}
    colSpan={props?.colSpan}
    count={props?.count}
    rowsPerPage={props?.rowsPerPage}
    page={props?.page}
    slotProps={{
      select: {
        inputProps: {
          'aria-label': 'rows per page',
          fontSize: '10px'
        },
      },
    }}
    onPageChange={props?.handleChangePage}
    onRowsPerPageChange={props?.handleChangeRowsPerPage}
    ActionsComponent={TablePaginationActions}
  />);
}

export default TablePaginationComponent;